import { put, select, take } from 'redux-saga/effects';

import { GO_TO_PAGE } from './actions';

import { notifications, GO_TO_PAGE_FAIL } from 'PipeRouter';

import { goToPageNumber as vsGoPageNumber } from 'services/learnkit';


function* goToPage() {
  while (true) {
    const { data } = yield take(GO_TO_PAGE);
    try {
      const pages = yield select(state => state.pageBreaks.pages);

      const requestedPageNumber = data.trim();
      const isValidPage = pages.filter(page => page.label === requestedPageNumber).length > 0;

      if (isValidPage) {
        yield vsGoPageNumber(requestedPageNumber);
      } else {
        throw new Error('invalid page number');
      }
    } catch (err) {
      window.logger.error('GO_TO_PAGE_FAIL', { err });
      yield put(notifications(GO_TO_PAGE_FAIL));
    }
  }
}


export default goToPage;
